import React from "react";

import { client, favoritesEnabled, serverUrl } from "../../config";
import { Col } from "react-bootstrap";
import { Button } from "@mui/material";
import GridItem from "../../partials/gridItem";
import FavouriteBtn from "../../partials/favouriteBtn";
import { useNavigate } from "react-router-dom";
import CheckIcon from '@mui/icons-material/CheckBoxOutlined';

export default function TrainingItem(props) {
  const navigate = useNavigate();

  const itemId = client === "equans" ? props.item?.nid : props.item?.nid;

  return (
    <GridItem
      xs={12} sm={6} md={3}
      itemClass="training"
      bundle={props.item?.bundle}
      nid={itemId}
      title={props.item?.title}
      field_body={props.item?.summary ? props.item?.summary : props.item?.body}
      category_label={props.item.category_labels}
      created={props.item?.created}
      hasImg={true}
      imgSrc={`${serverUrl}/${props.item.field_featured_image}`}
      alt={`Poster for test ${itemId}`}
      cardActionArea={true}
      cardActionCallBack={() => navigate(`/training/view/${itemId}`)}
      cardActions={true}
      chipWidth={8}
    >
      {props.item.submitted &&
        <Col xs={"auto"} className='d-flex align-items-center'>
          <Button
            variant="screenItemBtn"
            mode="default"
            onClick={() => { }}
          >
            <CheckIcon sx={{ fontSize: "0.9rem" }} />
          </Button>
        </Col>
      }
      {favoritesEnabled && (
        <FavouriteBtn
          id={itemId}
          mode={"default"}
          contentType={props.contentType}
          title={props.item?.title}
          thumbnail={props.item?.thumbnail}
        />
      )}
    </GridItem>
  )
}